import {getDetails, userRights, bulkUpdate, validateScreenName, createScreenName} from '@/libs/api/api'
import {message, loader, getImageUrl, onError, copyText, urlValidation, navigateTo, copyElement} from '@/libs/helper'
import {cloneDeep, isEmpty, orderBy} from 'lodash'
import constants from '@/libs/constant/constants'
import articlesTableMixin from '@/mixins/articlesTableMixin'

export default {
    name: 'AuthorForm',
    mixins: [articlesTableMixin],
    props: {},
    beforeMount() {
        this.$store.dispatch('setShowTableSettings', false)
        this.$store.dispatch('setContainer', true)
        this.getMetaList('AUTHOR')
        this.getUserRights()
    },
    components: {
        AddNewAuthor: ()=> import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AddNewAuthor/AddNewAuthor.vue') ,
        SocialMediaForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/SocialMediaForm/SocialMediaForm.vue'), 
        SearchDropdown: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/SearchDropdown/SearchDropdown.vue'), 
        RegisteredList: () => import(/* webpackChunkName: "group-admin" */'@/components/component/RegisteredList/RegisteredList.vue'), 
        AdminSearch: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AdminSearch/AdminSearch.vue'), 
        ImageUpload: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/ImageUpload/ImageUpload.vue'),
        LocationForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/LocationForm/LocationForm.vue'),
        ReplaceMeta: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/ReplaceMeta/ReplaceMeta.vue'),
        Table: () => import(/* webpackChunkName: "group-admin" */'@/components/component/Reuse/Table/Table.vue'),
    },

    watch: {
        activeTab (value) {
            if (value === constants.PUBLISHER_TABS.ARTICLES) {
                this.changePage(1)
            }
        }
    },

    data() {
        return {
            category: 'AUTHOR',
            sort: true,
            sortScrappedName: true,
            des: {},
            shortUrl: '',
            address: {},
            publisher: {},
            author: {},
            formData: {},
            publications: [],
            contentData: {},
            metaToAdd: {},
            isReplace: false,
            metaPublication: {},
            cleanInput: false,
            cleanPublicationInput: false,
            getUserData: {},
            isAddNewPublication: false,
            authorImage: {},
            socialMedia: {},
            imagePreview: '',
            url: '',
            isEmpty,
            copyText,
            getImageUrl,
            constants,
            activeTab: constants.PUBLISHER_TABS.CONTENT_DB,
            onError,
            navigateTo,
            tableSettings: {
                headings: {
                  scrapped_name: 'Scrapped Name',
                  publication_guid: 'Publication GUID',
                  publication_details: 'Publication Details',
                  settings: ''
                },
                filterable: [],
                filterByColumn: true,
                sortable: ['no'],
                // sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesortingz-a' },
                pagination: {chunk: 10}
              },
              columns: ['scrapped_name', 'publication_guid', 'publication_details', 'settings'],
              validateSlug: function (rule, value, callback) {
                // eslint-disable-next-line
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if ((isEmpty(value)) || (value && value.length > 20) || (value && regex.test(value))) callback(new Error('Invalid screen name'))
                if (!isEmpty(value) && checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                else callback()
            },
        }
    },
    methods: {
        /**
         * function to get the data of author form
         * @param {*} type 
         * @param {*} fetchData 
         */
        getMetaList: async function (type) {
            try{
                loader(this, true)
                this.formData = await getDetails(type.toLowerCase(), this.$route.params.id)
                this.contentData = cloneDeep(this.formData)
                this.setValues(this.contentData)
                loader(this, false)
            }
            catch (error) {
                loader(this, false)
                console.warn('A/P/P ERROR->', error)
            }
        },
        getUserRights: async function () {
            try {
                let body = {
                    type: this.category,
                    entity_id: this.$route.params.id
                }
                let users = await userRights(body)
                
                this.getUserData = users.user[0] || {}
            }
            catch (error) {
                return error
            }
        },
        setValues (data) {
            this.url = data.url && data.url || ''
            
            this.author = {
                first_name: data.first_name || '',
                middle_name: data.middle_name || '',
                last_name: data.last_name || '',
                website: '',
                screen_name: data.screen_name || ''
            }
            if (this.url.includes('https://')) {
                this.url = this.url.replace('https://', "")
                this.author.website = this.url.replace('https://', "")
            } else if (this.url.includes('http://')) {
                this.url = this.url.replace('http://', "")
                this.author.website = this.url.replace('http://', "")
            }
            this.des = {
                biography: data.biography || '',
                short_description: data.short_description || ''
            }

            this.authorImage = {
                avatar_image: data.avatar_image || '',
                imagePreview: data.imagePreview || null,
                _id: data._id
            }

            this.imagePreview = data.avatar_image || null

            this.address = {
                line1: (data.address && data.address.line1 && data.address.line1) || '',
                line2: (data.address && data.address.line2 && data.address.line2) || '',
                city: (data.address && data.address.city && data.address.city) || '',
                postal_code: (data.address && data.address.postal_code && data.address.postal_code) || '',
                country_code: (data.address && data.address.country_code && data.address.country_code) || '',
                country_name: (data.address && data.address.country_name && data.address.country_name) || ''
            }

            this.socialMedia = {
                social_media: data.social_media || [],
                _id: data._id
            }
 
            let publications = data.publications || []

            if (!isEmpty(publications)) {
                let newPublications = []
                publications.map(pub => {
                    pub.scrapped_name.map(scrappedName => {
                        pub.scrapped_name = scrappedName
                        newPublications.push({...pub, scrapped_name: scrappedName})
                    })
                })
                publications = newPublications
            }

            this.publications = publications

            if (this.author.screen_name === '') {
                this.createMetaScreenName()
            }
        },
        updateFormData (type, data) {
            switch (type) {
                case 'DESCRIPTION':
                    this.formData.biography ? this.formData.biography = data.biography : this.formData['biography'] = data.biography
                    this.formData.short_description ? this.formData.short_description = data.short_description : this.formData['short_description'] = data.short_description
                    break
                case 'LOCATION':
                    this.formData.address ? this.formData.address = data : this.formData['address'] = data
                    break
                case 'NAME':
                    this.formData.first_name ? this.formData.first_name = data.first_name : this.formData['first_name'] = data.first_name
                    this.formData.last_name ? this.formData.last_name = data.last_name : this.formData['last_name'] = data.last_name
                    this.formData.middle_name ? this.formData.middle_name = data.middle_name : this.formData['middle_name'] = data.middle_name
                    this.formData.url ? this.formData.url = data.url : this.formData['url'] = data.url
                    this.formData.screen_name ? this.formData.screen_name = data.screen_name : this.formData['screen_name'] = data.screen_name
                    break
                case 'PUBLICATIONS':
                    this.formData.publications ? this.formData.publications = cloneDeep(this.publications) : this.formData['publications'] = cloneDeep(this.publications)
                    break
                case 'IMAGE':
                    if (data !== undefined && data !== null) {
                        this.formData.avatar_image ? this.formData.avatar_image = data : this.formData['avatar_image'] = data
                    }
                    break
                case 'SOCIAL_MEDIA':
                    this.formData.social_media ? this.formData.social_media = data.social_media : this.formData['social_media'] = data.social_media
                    break
                    
            }
            this.contentData = cloneDeep(this.formData)
            this.setValues(this.contentData)        
        },
        webSiteValidation: function (rule, value, callback) {
            if (!isEmpty(value) && value.includes('http')) callback(new Error('Try adding url without web protocols(http or https)'))
            if (!isEmpty(value) && !urlValidation('https://' + value)) callback(new Error('Incorrect url'))
            else callback()   
        },
        submitAuthorNameForm (formName) {
            let author = cloneDeep(this.author)
            this.$refs[formName].validate(async(valid) => {
                if (!valid) return
                loader(this, true)
                // validate screen name
                if (this.author.screen_name !== '') {
                    let result = await this.validateMetaScreenName()
                    if (!result.isUnique) {
                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, "Screen name is already taken")
                        return
                    }
                } 
                let body = cloneDeep(author)
                if (author.website !== '' && author.website !== null) body.url = `https://${author.website}`
                else body.url = ''
                delete body.website
                body.entity_ids = [this.$route.params.id]
                bulkUpdate(this.category.toLowerCase(), body).then(() => {
                    message(this, constants.messageType.SUCCESS, "Updated Successfully")
                    this.updateFormData('NAME', body)
                    loader(this,false)
                }).catch(error => {
                    console.error(error)
                    loader(this,false)
                })  
            })  
        },
        EditAuthorDescription (formName) {
            let des = cloneDeep(this.des)
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                    loader(this, true)
                    let body = {
                        short_description: des.short_description,
                        biography: des.biography,
                        entity_ids: [this.$route.params.id]
                    }
                        bulkUpdate(this.category.toLowerCase(), body).then(() => {
                        message(this, constants.messageType.SUCCESS, "Updated Successfully")
                        this.updateFormData('DESCRIPTION', des)
                        loader(this, false)
                        }).catch(error => {
                        console.error(error)
                        loader(this, false)
                    })  
                
            }) 
        },
        editAuthorLocation (location) {
            loader(this, true)
            let address = cloneDeep(location)
            if (isEmpty(address.country_code)) delete address.country_code
            let body = {address, entity_ids: [this.$route.params.id]}        
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                message(this, constants.messageType.SUCCESS, "Update Successfully")
                this.updateFormData('LOCATION', location)
                loader(this,false)
            }).catch(error => {
                loader(this,false)
                console.error(error)
            })
        },
        editSocialMediaLinks () {
        },
        setMetaToAdd (item) {
            this.metaToAdd = item
        },
        addUser: async function () {
            if(isEmpty(this.metaToAdd) || (this.metaToAdd._id === this.getUserData._id)) {
                this.metaToAdd = {}
                return
            }          
            try {
                loader(this, true)
                let body= {
                    user_admin_action : {
                        user_id: this.metaToAdd._id,
                        action: 'REPLACE_WITH'
                    },
                    entity_ids: [this.$route.params.id]        
                }
                await bulkUpdate(this.category.toLowerCase(), body)
                this.getUserData = cloneDeep(this.metaToAdd)
                console.log('hiil', this.getUserData)
                this.metaToAdd = {}
                loader(this, false)
            } catch (error) {
                this.metaToAdd = {}
                loader(this, false)
                return error
            } 
        },
        removeUser () {
            if (isEmpty(this.getUserData)) return
            loader(this, true)
            let body= {
                user_admin_action : {
                    user_id: '',
                    action: 'REMOVE'
                },
                entity_ids: [this.$route.params.id]
            }            
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.getUserData = {}
                loader(this, false)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
            }).catch(error => {
                loader(this, false)
                return error
            })
        },
        removePublication: async function (item) {
            try {
                loader(this, true)
                let publications = cloneDeep(this.publications)
                publications = publications.filter(pub => pub._id !== item._id)
                let body = {
                    publications: {
                        publication_ids: [item.publication],
                        action: 'REMOVE'
                    },
                    entity_ids: [this.$route.params.id]
                }
                await bulkUpdate(this.category.toLowerCase(), body)
                this.publications = publications
                this.updateFormData('PUBLICATIONS', this.publications)
                message(this,constants.messageType.SUCCESS,"Updated Successfully")
                loader(this, false)
            } catch (error) {
                loader(this, false)
                return error
            }  
        },
        validateField (rule, value, callback) {
            let pattern = /^[^a-zA-Z0-9]+$/;
            if (!isEmpty(value) && pattern.test(value)) callback(new Error('Invalid characters'))
            else callback() 
        },
        handleCommand (command, data) {
            switch (command) {
                case 'COPY':
                    copyElement(this.$route.params.id)
                break
                case 'SHOW_IN_IP':
                    this.$router.push({name: `author-overview`, params: this.$route.params.id})
                break
                case 'REPLACE':
                    this.isReplace = true
                break
                case 'DELETE_PUBLICATION':
                    this.removePublication(data)
                break
                case 'EDIT_PUBLICATION':
                    this.$router.push({name: 'editPublications', params: {id: data.publication}})
                break
                case 'NEW_PUBLICATION':
                    this.isAddNewPublication = true
                break
                case 'REMOVE': 
                    this.removeMeta()
                break
            }
        },
        disabledDescriptionForm () {
            if (isEmpty(this.formData.short_description) && isEmpty(this.formData.biography) && isEmpty(this.des.short_description) && isEmpty(this.des.biography)) return true
            if (this.formData.short_description !== this.des.short_description || this.formData.biography !== this.des.biography) return false
            return true
        },
        disabledNameForm () {
            if (this.formData.first_name !== this.author.first_name || this.formData.last_name !== this.author.last_name || this.formData.middle_name !== this.author.middle_name || (this.url !== this.author.website) || this.formData.screen_name !== this.author.screen_name) return false
            return true
        },
        setPublication (item) {
            this.metaPublication = item
        },
        copyPublication () {
            if (!isEmpty(this.metaPublication)) {
                copyElement(this.metaPublication._id)
            }
        },
        buttonAction(type, isTrue) {
            this.isAddNewPublication = false
            if (isTrue) {
                this.getMetaList(this.category)
            }
        },
        replaceButtonAction (action, isTrue) {
            this.isReplace = false
            if (isTrue) {
                this.$store.dispatch('setCallPublishers', {label: 'Authors', className: 'info'})
            }
        },
        removeMeta () {
            let body = {
                entity_ids: [this.$route.params.id],
                delete_from_ecosystem: true
            }
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.$store.dispatch('setCallPublishers', {label: 'Authors', className: 'info'})
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        },
        removeImage () {
            loader (this, true)
            let body = {
               avatar_image: '',
               entity_ids: [this.$route.params.id]
           }
           bulkUpdate(this.category.toLowerCase(), body).then(() => {
               this.updateFormData('IMAGE', '')
               loader(this, false)
           }).catch(error => {
               console.error(error)
               loader(this, false)
           })
        },
        sortPublicationByName () {
            this.sort = ! this.sort
            let publications = cloneDeep(this.publications)
            this.publications = orderBy(publications, 'name', this.sort ? 'desc' : 'asc')
        },
        sortOnScrappedName () {
            this.sortScrappedName = ! this.sortScrappedName
            let publications = cloneDeep(this.publications)
            publications.sort(function (first, second) {
                let name1 = first.scrapped_name && first.scrapped_name ? first.scrapped_name : ''
                let name2 = second.scrapped_name && second.scrapped_name ? second.scrapped_name : ''
                if (name1 < name2) return -1 // sort string ascending
                if (name1 > name2) return 1
                return 0
              })
            this.publications = publications
        },
        
        /**
          * to validate the screen name
          */
        validateMetaScreenName: async function () {
            // body for api
            let body = {
                entity_type: this.category,
                screen_name: this.author.screen_name,
                entity_id: this.$route.params.id
            }
            // api call
            return await validateScreenName(body)
        },
        /**
         * to crete the screen name if screen name is not present
         */
        createMetaScreenName () {
            let name = (this.author.first_name && this.author.first_name.trim()) || ''
            if (this.author.last_name && this.author.last_name !== '' && this.author.last_name.trim() !== '') name = `${name} ${this.author.last_name.trim()}`
            // body for api
            let body = {
                entity_type: this.category,
                name
            }
            // api call
            createScreenName(body).then(response => {
                // assign screen name
                this.$set(this.author, 'screen_name', response.response)
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        }
    }
}